<template>
  <div>
    <svg
      v-if="isFiltered"
      v-tooltip.left="'Filter zurücksetzen'"
      @click="reset"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5 mr-1 text-gray-500 cursor-pointer hover:text-markencode-blue outline-none"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>

    <svg
      v-if="!isFiltered"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5 text-gray-300"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    isFiltered: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    reset() {
      this.$emit('filterResetted');
    }
  },
};
</script>
